import React, { useState } from "react";
import styles from "../styles/Analysis.module.css";
import mainStyles from "../styles/Main.module.css";
import Button, { RoundButton } from "../components/Button";
import { ArrowLeft, Pacman } from "../assets/Svg";
import HolderTypes from "../components/Analysis/HolderTypes";
import TokenDetails from "../components/Analysis/TokenDetails";
import AnalysisSplineGraph from "../components/Analysis/SplineGraph";
import PieChart from "../components/Analysis/PieChart";
import Accordion, {
  AccordionContentHeader,
  AccordionHeader,
} from "../components/AccordionSection";
import OthersToken from "../components/Analysis/OthersToken";
import History from "../components/Analysis/History";
import { useMediaQuery } from "react-responsive";
import numeral from "numeral";
import TopHolderItem from "../components/Analysis/TopHolderItem";
import { formatUnits } from "ethers";
import RangeSlider from "../components/Slider";

const Labels = ["Locked", "Unlocked", "Burned", "Owner"];
// const ChartData = [90, 5, 3, 2];
const Colors = ["#E1007F", "#49B7AB", "#EE5018", "#FFFFFF"];

export default function HolderAnalysis({ tokenData }) {
  const [hidden, setHidden] = useState(true);
  const [walletsSectionHidden, setWalletsSectionHidden] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  if (!tokenData) return null;

  console.log(tokenData);

  const displayData = hidden
    ? tokenData?.analysis?.holders?.top.slice(0, 5)
    : tokenData?.analysis?.holders?.top;

  // Get data for the pie chart from tokenData
  const ChartData = [
    parseInt(tokenData?.analysis?.balances?.locked),
    parseInt(tokenData?.analysis?.balances?.unlocked),
    parseInt(tokenData?.analysis?.balances?.burned),
    parseInt(tokenData?.analysis?.balances?.owner),
  ];

  return (
    <>
      <div className={`${styles.header} ${styles.holderHeader}`}>
        holders in time
        <Pacman />
      </div>
      <div className={`flex jc-fe al-ce`}>
        <RoundButton>1</RoundButton>
      </div>
      <AnalysisSplineGraph />
      <div className={`${styles.header} ${styles.holderHeader}`}>
        <div>
          Top 30 holders
          <Pacman />
        </div>
      </div>
      <div className={styles.holderSection}>
        <div className={styles.dataGrid}>
          <PieChart labels={Labels} data={ChartData} colors={Colors} />
          <div>
            {Labels.map((label, index) => (
              <HolderTypes
                key={index}
                name={label}
                percent={ChartData[index]}
                color={Colors[index]}
              />
            ))}
          </div>
          <div>
            <TokenDetails
              leftText={"Total Holders"}
              rightSection={tokenData?.analysis?.holders?.count}
            />
            <TokenDetails
              leftText={"Total Supply"}
              rightSection={numeral(
                tokenData.totalSupply.substring(
                  0,
                  // @todo check this apptoach
                  tokenData.totalSupply.length - 16
                )
              ).format("0a")}
            />
            <TokenDetails
              leftText={"top 10 holders ratio"}
              rightSection={
                <RangeSlider
                  percent={tokenData?.analysis?.holders?.topTenRatio}
                />
              }
            />
          </div>
        </div>
        {!isMobile ? <AccordionHeader /> : null}

        <div className={styles.othersTokenWrapper}>
          {displayData?.map((holder, index) => (
            <TopHolderItem
              key={index}
              index={index}
              holderAddress={holder.address}
              amount={formatUnits(
                holder.balance,
                parseInt(tokenData?.decimals)
              )}
            />
          ))}
          {hidden ? <div className={styles.blur}></div> : null}

          <div
            className={`${mainStyles.center} ${
              hidden ? mainStyles.seeFullListButton : mainStyles.hideBtn
            }`}
          >
            <Button
              variant="primary"
              onClick={() => {
                setHidden((prev) => !prev);
              }}
            >
              <span className={styles.seeFullList}>
                {hidden ? "see full list" : "hide full list"}
                <ArrowLeft />
              </span>
            </Button>
          </div>
        </div>
      </div>
      {!isMobile && (
        <div className={styles.walletBoughtCoin}>
          <div className={`${styles.header} ${styles.holderHeader}`}>
            <div>wallets that bought the coin in the first 10 mins</div>
          </div>
          <AccordionHeader bought />
          <AccordionContentHeader
            index={0}
            holderAddress={"0x000000"}
            holderAmount={"1000"}
            boughtText={"first 1 min"}
            link={"https://etherscan.io/address/0x000000"}
            arrow={false}
          />
          <AccordionContentHeader
            index={0}
            holderAddress={"0x000000"}
            holderAmount={"1000"}
            boughtText={"first 1 min"}
            link={"https://etherscan.io/address/0x000000"}
            arrow={false}
          />
          <AccordionContentHeader
            index={0}
            holderAddress={"0x000000"}
            holderAmount={"1000"}
            boughtText={"first 1 min"}
            link={"https://etherscan.io/address/0x000000"}
            arrow={false}
          />

          {walletsSectionHidden ? <div className={styles.blur}></div> : null}

          <div
            className={`${mainStyles.center} ${
              walletsSectionHidden
                ? mainStyles.seeFullListButton
                : mainStyles.hideBtn
            }`}
          >
            <Button
              variant="primary"
              onClick={() => {
                setWalletsSectionHidden((prev) => !prev);
              }}
            >
              <span className={styles.seeFullList}>
                {walletsSectionHidden ? "see full list" : "hide full list"}
                <ArrowLeft />
              </span>
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
